import { EAnoNe } from 'enums/anoNe';

const identifikaceOsobySelect = [
    {
        value: EAnoNe.ANO,
        labelcz: 'ANO'
    },
    {
        value: EAnoNe.NE,
        labelcz: 'NE'
    }
];

export default identifikaceOsobySelect;
